import passportClearFormatting from './passport-clear-formatting';

function passportIsValid(input: string | null | undefined): boolean {
  const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const cleared = passportClearFormatting(input);

  if (cleared.length !== 10) {
    return false;
  }

  for (let i = 0; i < cleared.length; i++) {
    if (!allowedSymbols.includes(cleared[i])) {
      return false;
    }
  }

  return true;
}

export default passportIsValid;
